/* eslint-disable @typescript-eslint/no-explicit-any */
type Extend<T extends Record<string, any>, U extends Record<string, any>> = (target: T, ...sources: Array<U>) => T & U;

const extend: Extend<object, object> = (target, ...sources) => {
  return sources.reduce(
    (acc, source) => {
      if (source) {
        acc = { ...acc, ...source };
      }
      return acc;
    },
    { ...target },
  );
};

export { extend };
